import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useRoomStore = defineStore('RoomStore', {
  state: () => {
    return {
      rooms: {
        content: [],
        pageInfo: {},
      },
      room: {
        roomInfo: {},
        basicInfo: {},
        detailInfo: {},
      },
      usersByRoom: {
        content: [],
        pageInfo: {},
      },
      roomHistories: {
        content: [],
        pageInfo: {},
      },
    };
  },
  actions: {
    /** [방 개설 현황] 운영중인 스터디(룸) 목록 조회 */
    async getRooms(params) {
      try {
        const { content, pageInfo } = await $api.get(`/active-studies`, { params });
        this.rooms.content = content;
        this.rooms.pageInfo = pageInfo;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 현황] 스터디(룸) 정보 조회 */
    async getRoom(params) {
      try {
        const { basicInfo, detailInfo } = await $api.get(`/active-studies/rooms/${params.roomId}`);
        this.room.basicInfo = basicInfo;
        detailInfo.defaultRoleCamera = detailInfo.defaultRoleCamera === 'on' ? 'ON' : 'OFF'
        detailInfo.defaultRoleMic = detailInfo.defaultRoleMic === 'on' ? 'ON' : 'OFF'
        this.room.detailInfo = detailInfo;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 현황] 스터디(룸) 정보 수정 */
    async putRoom(params) {
      return await $api.put(`/studies/rooms/${params.roomId}`, params.data);
    },

    /** [방 개설 현황] 스터디(룸) 정보 삭제 */
    async deleteRoom(params) {
      return await $api.delete(`/studies/rooms/${params.roomId}`);
    },

    /** [방 개설 현황] 스터디(룸) 대표 상세 정보 조회 */
    async getRoomInfo(params) {
      try {
        const res = await $api.get(`/active-studies/rooms/${params.roomId}/representative-info`);
        this.room.roomInfo = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 현황] 특정 스터디(룸) 방에 접속 중인 학생 목록 조회 */
    async getRoomUserList(params) {
      try {
        const usersByRoom = await $api.get(`/studies/rooms/${params.roomId}/room-users`);
        this.usersByRoom.content = usersByRoom;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 현황] 특정 스터디(룸)에 참여할 옵저버 입장 OTP 생성 */
    async joinRoom(params) {
      try {
        const { otp } = await $api.post(`/studies/otp`, params);
        return otp;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 이력] 개설한 스터디(룸) 목록 조회 */
    async getRoomHistoryList(params) {
      try {
        this.roomHistories = await $api.get(`/studies/histories`, { params });
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 이력] 특정 스터디(룸) 정보 조회 */
    async getRoomHistory(params) {
      try {
        const res = await $api.get(`/studies/rooms/${params.roomId}/histories`);
        this.room.basicInfo = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 이력] 특정 스터디(룸) 대표 상세 정보 조회 */
    async getRoomHistoryInfo(params) {
      try {
        const res = await $api.get(`/studies/rooms/${params.roomId}/histories/representative-info`);
        this.room.roomInfo = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [방 개설 이력] 특정 스터디(룸)에 학생 참여 이력 목록 조회 */
    async getRoomUserHistoryList(params) {
      return await $api.get(`/studies/rooms/${params.roomId}/room-users/histories`, { params });
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    }
  },
  getters: {},
});
